// Universal styles for typography
import { css } from 'styled-components'
import { space } from 'styled-system'
import { handleFontWeight } from './font'

export interface TypoStylesProps {
  bold?: boolean
  color?: string
  center?: boolean
  capitalize?: boolean
  uppercase?: boolean
  noWrap?: boolean
  inlineBlock?: boolean
  futura?: boolean
}

export const TypoStyles = css<TypoStylesProps>`
  ${space};
  line-height: 100%;
  color: ${({ color, theme }) => {
    if (color) {
      switch (color) {
        case 'primary':
          return theme.primary
        case 'secondary':
          return theme.secondary
        case 'tertiary':
          return theme.tertiary
        case 'error':
          return theme.red
        case 'highlight':
          return theme.highlight
        case 'inherit':
          return 'inherit'
      }
    } else {
      return theme.primary
    }
  }};

  ${({ bold }) =>
    bold
      ? css`
          font-weight: ${() => handleFontWeight('bold')};
        `
      : css`
          font-weight: ${() => handleFontWeight('light')};
        `};

  ${({ center }) =>
    center &&
    css`
      display: block !important;
      text-align: center;
    `};

  ${({ capitalize }) =>
    capitalize &&
    css`
      text-transform: capitalize;
    `};

  ${({ uppercase }) =>
    uppercase &&
    css`
      text-transform: uppercase;
    `};

  ${({ inlineBlock }) =>
    inlineBlock &&
    css`
      display: inline-block;
    `}

  ${({ futura }) =>
    futura &&
    css`
      font-family: Futura, sans-serif;
    `};
`
